const FIRST_NAME_REGEX = /^[\sa-zA-Z0-9-.,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{1,50}$/;

const LAST_NAME_REGEX = /^[\sa-zA-Z0-9-.,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{1,50}$/;

const PHONE_NUMBER_REGEX = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;

const ADDRESS1_REGEX = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/;

const ADDRESS2_REGEX = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/;

const CITY_REGEX = /^[\sa-zA-Z0-9-().,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,50}$/;

const STATE_REGEX = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/;

const ZIP_CODE_REGEX = /^(?![-]+$)[\sa-zA-Z0-9-]{2,16}$/;

const US_ONLY_REGEX = /^US$/;

// eslint-disable-next-line no-useless-escape
const DOB_REGEX = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;

export const REGEX = {
  FIRST_NAME: FIRST_NAME_REGEX,
  LAST_NAME: LAST_NAME_REGEX,
  ADDRESS1: ADDRESS1_REGEX,
  ADDRESS2: ADDRESS2_REGEX,
  CITY: CITY_REGEX,
  STATE: STATE_REGEX,
  ZIP_CODE: ZIP_CODE_REGEX,
  DOB: DOB_REGEX,
  US_ONLY_REGEX: US_ONLY_REGEX,
  PHONE_NUMBER_REGEX: PHONE_NUMBER_REGEX,
};
